import normalizeGraphqlName from './normalizeGraphqlName.js';

const classifyLogicalToken = (name) => {
  const normalized = normalizeGraphqlName(name);

  if (normalized === 'and') {
    return 'and';
  }

  if (normalized === 'or') {
    return 'or';
  }

  if (normalized === 'not') {
    return 'not';
  }

  return null;
};

export default classifyLogicalToken;
